// One activity to a calendar (blind rounds 1-2: marco, lena): drafted by Astra (copy lane, build/astra/copy-calendar-one-prompt.md ->
// copy-calendar-one.txt), gated by Claude 10/10/26 (no dashes / exclamation marks / "plan" / listings; word limits). Do not edit by hand.
export const CAL_ONE: Record<string, string> = {
  "calendar.one_apple_done": "Calendar file downloaded",
  "calendar.one_google_done": "Google Calendar opened",
  "calendar.one_apple_line": "Calendar file downloaded. Select Add in your Calendar app to finish.",
  "calendar.one_google_line": "Google Calendar opened in a new tab. Press Save there to finish.",
}
export const calOne = (key: string): string => CAL_ONE[key] ?? key
